<!--
 * @Author: natsu
 * @Date: 2020-09-02 16:51:59
 * @LastEditors: natsu
 * @LastEditTime: 2021-09-09 16:13:09
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Vue</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vue/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.7.16",
          linkList: [
            ur + "2.7.16/vue.js",
            ur + "2.7.16/vue.min.js",
            ur + "2.7.16/vue.common.js",
            ur + "2.7.16/vue.esm.js",
            ur + "2.7.16/vue.esm.browser.js"
          ]
        },
        {
          label: "2.7.8",
          linkList: [
            ur + "2.7.8/vue.js",
            ur + "2.7.8/vue.min.js",
            ur + "2.7.8/vue.common.js",
            ur + "2.7.8/vue.esm.js",
            ur + "2.7.8/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.14",
          linkList: [
            ur + "2.6.14/vue.js",
            ur + "2.6.14/vue.min.js",
            ur + "2.6.14/vue.common.js",
            ur + "2.6.14/vue.esm.js",
            ur + "2.6.14/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.12",
          linkList: [
            ur + "2.6.12/vue.js",
            ur + "2.6.12/vue.min.js",
            ur + "2.6.12/vue.common.js",
            ur + "2.6.12/vue.esm.js",
            ur + "2.6.12/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.11",
          linkList: [
            ur + "2.6.11/vue.js",
            ur + "2.6.11/vue.min.js",
            ur + "2.6.11/vue.common.js",
            ur + "2.6.11/vue.esm.js",
            ur + "2.6.11/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.10",
          linkList: [
            ur + "2.6.10/vue.js",
            ur + "2.6.10/vue.min.js",
            ur + "2.6.10/vue.common.js",
            ur + "2.6.10/vue.esm.js",
            ur + "2.6.10/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.9",
          linkList: [
            ur + "2.6.9/vue.js",
            ur + "2.6.9/vue.min.js",
            ur + "2.6.9/vue.common.js",
            ur + "2.6.9/vue.esm.js",
            ur + "2.6.9/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.8",
          linkList: [
            ur + "2.6.8/vue.js",
            ur + "2.6.8/vue.min.js",
            ur + "2.6.8/vue.common.js",
            ur + "2.6.8/vue.esm.js",
            ur + "2.6.8/vue.esm.browser.js"
          ]
        },
        {
          label: "2.6.0",
          linkList: [
            ur + "2.6.0/vue.js",
            ur + "2.6.0/vue.min.js",
            ur + "2.6.0/vue.common.js",
            ur + "2.6.0/vue.esm.js",
            ur + "2.6.0/vue.esm.browser.js"
          ]
        },
        {
          label: "2.5.21",
          linkList: [ur + "2.5.21/vue.runtime.min.js"]
        },
        {
          label: "2.5.17",
          linkList: [
            ur + "2.5.17/vue.js",
            ur + "2.5.17/vue.min.js",
            ur + "2.5.17/vue.common.js",
            ur + "2.5.17/vue.esm.js",
            ur + "2.5.17/vue.esm.browser.js"
          ]
        },
        {
          label: "2.5.17-beta.0",
          linkList: [
            ur + "2.5.17-beta.0/vue.js",
            ur + "2.5.17-beta.0/vue.min.js",
            ur + "2.5.17-beta.0/vue.common.js",
            ur + "2.5.17-beta.0/vue.esm.js",
            ur + "2.5.17-beta.0/vue.esm.browser.js"
          ]
        },
        {
          label: "2.5.16",
          linkList: [
            ur + "2.5.16/vue.js",
            ur + "2.5.16/vue.min.js",
            ur + "2.5.16/vue.common.js",
            ur + "2.5.16/vue.esm.js",
            ur + "2.5.16/vue.esm.browser.js"
          ]
        },
        {
          label: "2.5.15",
          linkList: [
            ur + "2.5.15/vue.js",
            ur + "2.5.15/vue.min.js",
            ur + "2.5.15/vue.common.js",
            ur + "2.5.15/vue.esm.js",
            ur + "2.5.15/vue.esm.browser.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVue.vue